import { GridPro, GridProRendererTypes, foundationGridProShadowOptions, defaultGridProConfig as foundationConfig, } from '@genesislcap/grid-pro';
import { ZeroNumberEditor, ZeroSelectEditor, ZeroMultiselectEditor, ZeroDateEditor, ZeroStringEditor, } from './cell-editors';
import { ZeroEditableRenderer, ZeroAgActionRenderer, ZeroAgActionsMenuRenderer, ZeroBooleanRenderer, } from './cell-renderers';
import { zeroGridProStyles as styles } from './grid-pro.styles';
import { zeroGridProTemplate as template } from './grid-pro.template';
import { themeGenesisRapid, themeGenesisRapidDark } from './themes';
const defaultAgHeight = 32;
const defaultRapidTheme = 'ag-theme-genesis-rapid-dark';
/**
 * @tagname %%prefix%%-grid-pro
 */
export class ZeroGridPro extends GridPro {
    constructor() {
        super(...arguments);
        /**
         * Sets default theme to Rapid
         * @override
         */
        this.theme = defaultRapidTheme;
    }
    themeChanged(oldValue, newValue) {
        if (!oldValue && newValue !== defaultRapidTheme)
            return;
        super.themeChanged(oldValue, newValue);
    }
    /**
     * Handles extra ZERO configs
     * @override
     */
    set gridOptions(options) {
        var _a, _b;
        options.components = {
            [GridProRendererTypes.action]: ZeroAgActionRenderer,
            [GridProRendererTypes.actionsMenu]: ZeroAgActionsMenuRenderer,
            [GridProRendererTypes.boolean]: ZeroBooleanRenderer,
            [GridProRendererTypes.editable]: ZeroEditableRenderer,
            [GridProRendererTypes.selectEditor]: ZeroSelectEditor,
            [GridProRendererTypes.numberEditor]: ZeroNumberEditor,
            [GridProRendererTypes.multiselectEditor]: ZeroMultiselectEditor,
            [GridProRendererTypes.dateEditor]: ZeroDateEditor,
            [GridProRendererTypes.stringEditor]: ZeroStringEditor,
        };
        const isRapidTheme = this.theme === themeGenesisRapid || this.theme === themeGenesisRapidDark;
        if (isRapidTheme) {
            this.headerHeight = (_a = options.headerHeight) !== null && _a !== void 0 ? _a : defaultAgHeight;
            this.rowHeight = (_b = options.rowHeight) !== null && _b !== void 0 ? _b : defaultAgHeight;
        }
        super.gridOptions = options;
    }
}
// explicitly declaring for extensibility
export const zeroGridProShadowOptions = foundationGridProShadowOptions;
export const zeroDefaultGridProConfig = foundationConfig;
export const zeroGridPro = ZeroGridPro.compose(Object.assign({ baseName: 'grid-pro', template,
    styles, shadowOptions: zeroGridProShadowOptions }, zeroDefaultGridProConfig));
